import { render, staticRenderFns } from "./CustomerPagination.vue?vue&type=template&id=6427432a&"
import script from "./CustomerPagination.vue?vue&type=script&lang=js&"
export * from "./CustomerPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports